import { apiClient } from '../../../util/apiClient/commonApiClient'
import { EndGameRequest } from './EndGameRequest'
import { EndGameResponse } from './EndGameResponse'

export declare interface IEndGameApi {
  endGame(input: EndGameRequest): Promise<EndGameResponse>
}

export function createEndGameApi(gameName: string): IEndGameApi {
  return {
    async endGame(input: EndGameRequest): Promise<EndGameResponse> {
      const response = await apiClient.post<EndGameResponse>(`${gameName}/EndGame`, input)
      return response.data
    },
  }
}
